import React, { useReducer, useEffect,useState } from "react";
import { Alert, Card, Col, Row, Table, Badge, Image,Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";

import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayRichText from "../../../../UI/modules/fieldsDisplay/ModuleDisplayRichText";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import ReactFancyBox from "react-fancybox";
import parse from "html-react-parser";
import axios from "../../../../../config/axios";
import AddNewsEventsPicture from "./AddNewsEventsPicture";
import GalleryItem from "./GalleryPicture";
import { detailsReducer, memberDetailsInitialState } from "../../reducers/detailsReducer";
import useConfirm from "../../../../../HOC/custom/useConfirm";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../../../config/toastNotification";

const Details = ({
  item,
  loadItem,
  detailsDispatch
}) => {
 const { confirm } = useConfirm();
  const [show, setShow] = useState(false);
  const [galleryState, galleryDispatch] = useReducer(
    detailsReducer,
    memberDetailsInitialState
  );

  const confirmAndRemovePicture = async (pictureId) => {
    const isConfirmed = await confirm(
      `Do you really want to remove this picture?`
    );

    if (isConfirmed) {
      await removePicture(pictureId);
    }
  };

  const removePicture = async (pictureId) => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.delete(`fossil-site-gallery/${pictureId}`, {
        albumId: item._id,
      });
      loadItem();
      // detailsDispatch({
      //     type: "DELETE_SUCCESS"
      // });
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Media removed successfully.`,
        type: "success",
      });
    } catch (error) {
      detailsDispatch({
        type: "BLOCK_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        detailsDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };

  const confirmAndArchivePicture = async (pictureId) => {
    const isConfirmed = await confirm(
      `Do you really want to archive this media?`
    );

    if (isConfirmed) {
      await changeStatusPicture(pictureId, "0");
    }
  };

  const confirmAndRestorePicture = async (pictureId) => {
    const isConfirmed = await confirm(
      `Do you really want to restore this media?`
    );

    if (isConfirmed) {
      await changeStatusPicture(pictureId, "1");
    }
  };

  const changeStatusPicture = async (pictureId, status) => {
    console.log("In block Item Function");
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.post(`fossil-site-gallery/change-status`, {
        id: pictureId,
        status,
      });
      loadItem();
      // detailsDispatch({
      //     type: "DELETE_SUCCESS"
      // });
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Media ${
          status === "1" ? "restored" : "archived"
        } successfully.`,
        type: "success",
      });
    } catch (error) {
      detailsDispatch({
        type: "BLOCK_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        detailsDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };

  const loadGallery = async () => {
    if (item._id) {
      galleryDispatch({
        type: "FETCH_REQUEST",
      });
      try {
        const res = await axios.get(`news-events-gallery/${item._id}`); //
        galleryDispatch({
          type: "FETCH_SUCCESS",
          payload: res.data,
        });
        console.log(res.data, "154646");
      } catch (error) {
        galleryDispatch({
          type: "FETCH_FAILURE",
          payload: error,
        });
      }
    }
  };
  useEffect(() => {
    loadGallery();
  }, [item._id]);

  // const getItems = () => {
  //   let items = [];

  //   if (item.shortDescription) {
  //     items = [
  //       ...items,
  //       {
  //         text: "Short Description",
  //         value: item.shortDescription,
  //         type: "text",
  //       },
  //     ];
  //   }

  //   return items;
  // };
  // const [detailsState, detailsDispatch] = useReducer(
  //   detailsReducer,
  //   detailsInitialState
  // );
  // const loadItem = async () => {
  //   if (item.galleryAlbumId) {
  //     detailsDispatch({
  //       type: "FETCH_REQUEST",
  //     });
  //     try {
  //       const res = await axios.get(`media-gallery-albums/${item.galleryAlbumId}`); //
  //       detailsDispatch({
  //         type: "FETCH_SUCCESS",
  //         payload: res.data,
  //       });
  //     } catch (error) {
  //       detailsDispatch({
  //         type: "FETCH_FAILURE",
  //         payload: error,
  //       });
  //     }
  //   }
  // };
  // useEffect(() => {
  //   loadItem();
  // }, [item.galleryAlbumId]);
  // function getMediaSummary(data) {
  //   let imageCount = 0;
  //   let videoCount = 0;

  //   if (!data?.items || !Array.isArray(data.items)) {
  //     return "0 images, 0 videos";
  //   }

  //   data.items.forEach((item) => {
  //     if (item.status === "1") {
  //       if (item.type === "image") {
  //         imageCount++;
  //       } else if (item.type === "video") {
  //         videoCount++;
  //       }
  //     }
  //   });


  //   // Otherwise return image count + video count
  //   return `${imageCount} ${imageCount === 1 ? 'image' : 'images'}, ${videoCount} ${videoCount === 1 ? 'video' : 'videos'}`;
  // }


  return (
    <>
      <Row>
        <Col>
          <Card className="item  mb-2">
            <Card.Header className="ps-1 pe-2 py-0">
              <Card.Title className="m-0 p-0 ">
                <div className="d-flex ImageSectionSpacing">
                  <div className="position-relative ms-1 me-2">
                    <div className="ms-1 me-2">
                      <i className="fas fa-newspaper position-relative usericon ">
                        {(item.status === "0" || item.status === 0) && (
                          <i className="fas fa-ban position-absolute ms-1  banned2"></i>
                        )}
                      </i>
                    </div>
                  </div>

                  <div className="d-flex flex-column ms-1">
                    <span className="m-0 text-bold memberName text-red">
                      {item.title}
                    </span>

                    <span className="font-italic font-small font-weight-normal text-success fs-8  ">
                      <span className="membershipId">{item.date}</span>
                    </span>
                  </div>
                </div>
              </Card.Title>

              <div className="card-tools endColumn">
                <div className=" text-right  mt-1 mt-xl-2 mt-lg-2 mt-md-2 pt-xl-1 pt-lg-1 pt-md-1 pt-0">
                  {(item.showOnHomePage === "1" ||
                    item.showOnHomePage === 1) && (
                      <span className="badge homePageShow me-1 text-white">
                        Showing on Home Page
                      </span>
                    )}
                  <span className="badge badge-light me-1 text-dark">
                    Status :{" "}
                    <span class="text-secondary">
                      <ModuleDisplayBoolean
                        value={item.status}
                        trueValue="Enabled"
                        falseValue="Disabled"
                      />{" "}
                    </span>
                  </span>
                  {item.createdAt && (
                    <span class="badge badge-light me-1 text-dark">
                      Created Date :{" "}
                      <span class="text-secondary">
                        <ModuleDisplayDate value={item.createdAt} />{" "}
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </Card.Header>

            <Card.Body className="p-2">
              <Row>

                {item.image && (
                  <Col  className="newsImageCol">
                    
                      <div className="newsImage mt-2">
                        <ReactFancyBox
                          thumbnail={
                            process.env.REACT_APP_BACKEND_URL +
                            "public/" +
                            item.image
                          }
                          image={
                            process.env.REACT_APP_BACKEND_URL +
                            "public/" +
                            item.image
                          }
                          caption="Album Cover"
                        />
                      </div>
                    

                  </Col>
                )}
               
                <Col className="col-xs-12">
                 {/* {item.galleryAlbumId &&
                  <>
                    <div className="mt-2">
                   
                      {detailsState.data && detailsState.data.item &&
                        <Link to={`/media-gallery-albums/${item.galleryAlbumId}`} >

                          <Card>
                            <Card.Header className="px-2 py-1 d-flex align-items-center">

                              <span class="badge badge-warning me-1 text-dark attached-gallery">
                                Attached Gallery
                              </span>

                              {detailsState.data.item.image && (
                                <div className="" style={{ maxWidth: 80 }}>
                                  <div className="newsImage mt-0">
                                    <ReactFancyBox
                                      thumbnail={
                                        process.env.REACT_APP_BACKEND_URL +
                                        "public/" +
                                        detailsState.data.item.image
                                      }
                                      image={
                                        process.env.REACT_APP_BACKEND_URL +
                                        "public/" +
                                        detailsState.data.item.image
                                      }
                                      caption="Album Cover"
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="py-3 px-3">
                                <p className="text-dark font-weight-bold  mb-0 fs-5">
                                  {detailsState.data.item.title}
                                </p>

                                <p className="text-info  mb-0 fs-7">
                                  {getMediaSummary(detailsState.data.item)}
                                </p>


                              </div>

                            </Card.Header>
                           

                          </Card>
                        </Link>}
                    </div>
                  </>} */}
                  {/* <StatsListing items={getItems()} /> */}
                  {item.shortDescription && (
                    <>
                      <Alert variant="light mb-0 pb-1 mb-2 px-2 pt-0 messageWidth">
                        <span className=" m-0 text-bold text-dark px-0 font-small ">
                          Short Description: <span className="font-small text-normal ms-0 me-1 px-1 text-dark mb-0">
                            {parse(item.shortDescription)}
                          </span>
                        </span>

                      </Alert>
                    </>
                  )}
                  {item.description && (
                    <>
                      <Alert variant="secondary lightGray mb-0 pb-1 mt-2 px-1 pt-0 messageWidth">
                        {/* <span className="m-0 text-bold text-dark px-1 font-small">
                          Short Description:
                        </span>
                        <p className="font-small me-1 px-1 text-dark mb-0">
                          {parse(item.shortDescription)}
                        </p> */}
                        <span className="m-0 text-bold text-dark px-1 font-small">
                          Description:
                        </span>
                        <p className="font-small me-1 px-1 text-dark mb-0">
                          {parse(item.description)}
                        </p>
                      </Alert>
                    </>
                  )}
                </Col>

              </Row>

            </Card.Body>
          </Card>

           <Card className="borderCream">
            <Card.Header className="ps-1 pe-2 py-0">
              <div className="d-flex  my-2 mx-2">
                <h5 className="text-bold">Gallery </h5> &nbsp; &nbsp;{" "}
                <Button
                  title="Please click to add media"
                  variant="primary"
                  size="sm"
                  className="rounded-circle roundButton"
                  onClick={() => setShow(true)}
                >
                  <i className="fas fa-plus"></i>
                </Button>
              </div>
            </Card.Header>
            <Card.Body className="px-2 pb-0 pt-0">
              <Row className="circleMembersList">
                {galleryState.data.items &&
                galleryState.data.items.length > 0 ? (
                  <>
                    {galleryState.data.items.map((picture, index) => {
                      return (
                        <Col
                          key={index}
                          xs={12}
                          sm={6}
                          md={4}
                          lg={3}
                          className="pt-1"
                        >
                          <GalleryItem
                            picture={picture}
                            loadItem={loadItem}
                            confirmAndRemovePicture={confirmAndRemovePicture}
                            confirmAndArchivePicture={confirmAndArchivePicture}
                            confirmAndRestorePicture={confirmAndRestorePicture}
                          />
                        </Col>
                      );
                    })}
                  </>
                ) : (
                  <Alert variant="warning" className="mb-0">
                    No records found.
                  </Alert>
                )}
              </Row>
            </Card.Body>
          </Card>

        </Col>
      </Row>

      <AddNewsEventsPicture
        show={show}
        setShow={setShow}
        parentId={item._id}
        loadItem={loadItem}
      />
    </>
  );
};

export default Details;
